module.exports = __webpack_public_path__ + "static/media/explicit_category.5241de80.png";